import { inject, NgModule } from '@angular/core';

import { Chart } from 'chart.js';
import { ConstantsParserService } from '@ui/legacy-lib';

import { environment } from 'landlord-env';

import { ENVIRONMENT_CONFIG } from '@ui/landlord/shared/config';
import { CHART_JS_REF, ChartAdapterService } from './chart';

@NgModule({
  providers: [
    { provide: CHART_JS_REF, useValue: Chart },
    { provide: ENVIRONMENT_CONFIG, useValue: environment },
    ChartAdapterService,
    ConstantsParserService
  ]
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error(
        `${String(
          parentModule
        )} has already been loaded. Import core module in the AppModule only.`
      );
    }
  }
}
